"use strict";

module.exports = function getPropertyDescriptor(object, property) {
    var proto = object;
    var descriptor;

    while (proto && !(descriptor = Object.getOwnPropertyDescriptor(proto, property))) {
        proto = Object.getPrototypeOf(proto);
    }
    return descriptor;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/sinon/lib/sinon/util/core/get-property-descriptor.js
// module id = 116
// module chunks = 0